// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2PdiM","signatureButtonsRight":"ModalSign_signatureButtonsRight__14j7t"};